const FooterLogo = (props) => (
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 195.6 64.3"
        {...props}
    >
        <defs>
            <style>
                {
                    "\n      .st0 {\n        fill: url(#radial-gradient);\n      }\n\n      .st1 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st3 {\n        fill: #6792b2;\n      }\n\n      .st4 {\n        fill: #858585;\n      }\n\n      .st5 {\n        fill: #c96;\n      }\n\n      .st6 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st7 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st8 {\n        fill: url(#radial-gradient3);\n      }\n    "
                }
            </style>
            <radialGradient
                id="radial-gradient"
                cx={0}
                cy={27.6}
                fx={0}
                fy={27.6}
                r={17.5}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#603" />
                <stop offset={1} stopColor="#903" />
            </radialGradient>
            <radialGradient
                id="radial-gradient1"
                cx={20.5}
                cy={6.5}
                fx={20.5}
                fy={6.5}
                r={14.6}
                gradientTransform="translate(0 -1.8) scale(1 1)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#c19d3d" />
                <stop offset={0.4} stopColor="#dec966" />
                <stop offset={0.8} stopColor="#f0e480" />
                <stop offset={1} stopColor="#f7ef8a" />
            </radialGradient>
            <radialGradient
                id="radial-gradient2"
                cx={7.6}
                cy={52.7}
                fx={7.6}
                fy={52.7}
                r={13.6}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#363" />
                <stop offset={1} stopColor="#693" />
            </radialGradient>
            <radialGradient
                id="radial-gradient3"
                cx={36.5}
                cy={58.9}
                fx={36.5}
                fy={58.9}
                r={12.7}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#633" />
                <stop offset={1} stopColor="#963" />
            </radialGradient>
            <radialGradient
                id="radial-gradient4"
                cx={56.1}
                cy={38.8}
                fx={56.1}
                fy={38.8}
                r={15}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#306" />
                <stop offset={1} stopColor="#639" />
            </radialGradient>
            <radialGradient
                id="radial-gradient5"
                cx={48.8}
                cy={11.9}
                fx={48.8}
                fy={11.9}
                r={13.6}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#369" />
                <stop offset={1} stopColor="#6cc" />
            </radialGradient>
        </defs>
        <g>
            <path
                className="st5"
                d="M162.4,12.2c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5-1.6,3.5-3.5,3.5h0c-1.9,0-3.5-1.6-3.5-3.5h0ZM167.6,12.2c.1-.9-.5-1.8-1.5-1.9-.9-.1-1.8.5-1.9,1.5v.4c0,1,.6,1.9,1.7,1.9s1.7-.9,1.7-1.8c0,0,0-.1,0-.1Z"
            />
            <path
                className="st5"
                d="M171.1,15.4v-5h-1.1v-1.5h1.1v-.4c-.1-1.2.8-2.2,1.9-2.3h.3c.6,0,1.3.2,1.7.6l-.7,1c-.2-.2-.4-.3-.7-.2-.5,0-.8.3-.8.9v.4h1.3v1.5h-1.3v5h-1.8Z"
            />
            <path
                className="st5"
                d="M176.2,30.7v-.7c-.5.5-1.3.9-2.1.9-1.2,0-2.2-.9-2.3-2.1h0c0-1.3.9-2.2,2.1-2.2h.2c.8,0,1.5.2,2.1.8v-.9c0-.7-.5-1.1-1.5-1.1s-1.4.3-1.9.8l-.7-1.2c.8-.7,1.8-1.1,2.9-1,1.5,0,2.9.6,2.9,2.5v4.2h-1.7ZM176.2,29.2v-.8c-.4-.4-.9-.6-1.4-.5-.7,0-1.2.4-1.2,1s.5,1,1.2,1c.5,0,1-.2,1.4-.6h0Z"
            />
            <path
                className="st5"
                d="M184,30.7v-3.9c0-.9-.5-1.2-1.2-1.2s-1.2.3-1.5.8v4.4h-1.7v-6.6h1.7v.9c.6-.7,1.4-1,2.3-1,1.5,0,2.1.8,2.1,2.1v4.6h-1.7Z"
            />
            <path
                className="st5"
                d="M191.9,30.7v-.8c-.5.6-1.2,1-2,1-1.6,0-2.9-1.3-2.9-3.5s1.2-3.5,2.9-3.5,1.5.4,2,1v-3.3h1.8v9h-1.8ZM191.9,28.6v-2.3c-.4-.5-.9-.7-1.5-.7-1,0-1.6.8-1.6,1.9s.7,1.9,1.6,1.9c.7,0,1.2-.3,1.5-.8h0Z"
            />
        </g>
        <g>
            <path
                className="st3"
                d="M72.2,13.9l1.3-1.8c.9,1,2.2,1.5,3.5,1.5s1.9-.6,1.9-1.2c0-1.9-6.3-.6-6.3-4.7s1.6-3.3,4.2-3.3c1.6,0,3.1.5,4.3,1.5l-1.3,1.7c-.9-.8-2-1.2-3.2-1.2s-1.6.5-1.6,1.1c0,1.8,6.3.5,6.3,4.7s-1.5,3.5-4.4,3.5c-1.7.1-3.4-.5-4.7-1.7Z"
            />
            <path
                className="st3"
                d="M82.6,16.7c.2,0,.4.1.7.1.4,0,.9-.2,1.1-.5l.3-.7-3.2-8h2.2l2.1,5.5,2.1-5.5h2.2l-3.7,9.2c-.6,1.5-1.6,1.9-3,1.9-.4,0-.7,0-1-.1l.3-1.9Z"
            />
            <path
                className="st3"
                d="M100.9,15.4v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-8h2.1v1c.7-.7,1.6-1.2,2.6-1.2,1-.1,1.9.5,2.2,1.5.6-.9,1.6-1.5,2.7-1.5s2.3.8,2.3,2.4v5.7h-2.1Z"
            />
            <path
                className="st3"
                d="M107.1,14.4v4.1h-2.1V7.6h2.1v1c.6-.8,1.5-1.2,2.4-1.2,2.1,0,3.5,1.5,3.5,4.2s-1.5,4.2-3.5,4.2c-1,0-1.9-.5-2.4-1.3ZM110.9,11.4c0-1.4-.8-2.3-2-2.3s-1.3.4-1.8.9v2.8c.4.5,1.1.9,1.8.9,1.2,0,2-.9,2-2.3h0Z"
            />
            <path
                className="st3"
                d="M114.1,11.4c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2-1.9,4.2-4.2,4.2h0c-2.3,0-4.2-1.9-4.2-4.2h0ZM120.3,11.4c0-1.2-.7-2.3-2.1-2.3s-2,1.1-2,2.3.7,2.3,2,2.3,2.1-1,2.1-2.3Z"
            />
            <path
                className="st3"
                d="M123.3,14.4l.9-1.5c.8.7,1.8,1,2.7,1.1.9,0,1.3-.4,1.3-.9,0-1.3-4.7-.2-4.7-3.4s1.2-2.5,3.3-2.5,2.3.4,3.2,1.1l-.9,1.5c-.6-.6-1.5-.9-2.4-.9s-1.3.4-1.3.8c0,1.2,4.7.2,4.7,3.4s-1.2,2.6-3.5,2.6c-1.3,0-2.5-.5-3.5-1.3Z"
            />
            <path
                className="st3"
                d="M131.6,5.4c0-.7.5-1.3,1.2-1.3s1.3.5,1.3,1.2-.5,1.3-1.2,1.3h0c-.7,0-1.3-.5-1.3-1.2ZM131.9,15.4v-8h2.1v8h-2.1Z"
            />
            <path
                className="st3"
                d="M141.4,15.4v-1c-.7.8-1.7,1.2-2.8,1.2-1.8,0-2.6-.9-2.6-2.5v-5.6h2.1v4.8c-.1.7.4,1.3,1,1.5h.4c.7,0,1.4-.4,1.8-.9v-5.3h2.1v8h-2.1Z"
            />
            <path
                className="st3"
                d="M155.4,15.4v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-8h2.1v1c.7-.7,1.6-1.2,2.6-1.2,1-.1,1.9.5,2.2,1.5.6-.9,1.6-1.5,2.7-1.5s2.3.8,2.3,2.4v5.7h-2Z"
            />
            <path
                className="st3"
                d="M80.5,30.7l-5.2-7.2v7.2h-2.3v-10.9h2.4l5.1,6.9v-6.9h2.3v10.9h-2.3Z"
            />
            <path
                className="st3"
                d="M89.6,30.7v-.8c-.7.7-1.6,1-2.5,1-1.5,0-2.7-1-2.8-2.5h0c0-2,1.5-2.7,2.8-2.7.9,0,1.9.3,2.5,1v-1.1c0-.8-.7-1.3-1.8-1.3s-1.7.4-2.3.9l-.8-1.4c1-.9,2.2-1.3,3.5-1.3,1.8,0,3.5.7,3.5,3v5.1h-2.1ZM89.6,28.8v-1c-.4-.5-1-.7-1.7-.7-.9,0-1.5.4-1.5,1.2s.7,1.2,1.5,1.2c.7,0,1.3-.2,1.7-.7h0Z"
            />
            <path
                className="st3"
                d="M99.2,30.7v-4.8c.1-.7-.4-1.4-1.1-1.5h-.4c-.7,0-1.4.4-1.8.9v5.3h-2.1v-7.9h2.1v1c.7-.8,1.7-1.2,2.8-1.2,1.8,0,2.6,1,2.6,2.6v5.6h-2.1Z"
            />
            <path
                className="st3"
                d="M102.8,26.7c0-2.3,2.1-4.1,4.4-4.1,2.2,0,3.9,1.8,4.1,4.1h0c0,2.3-1.7,4.3-4.1,4.4-2.3,0-4.3-1.7-4.4-4.1v-.3ZM109.1,26.7c0-1.2-.7-2.3-2.1-2.3s-2,1.1-2,2.3.7,2.3,2,2.3,2.1-1,2.1-2.3h0Z"
            />
            <path
                className="st3"
                d="M112.1,29.7l.9-1.5c.8.7,1.8,1,2.7,1.1.9,0,1.3-.4,1.3-.9,0-1.3-4.7-.2-4.7-3.4s1.2-2.5,3.3-2.5,2.3.4,3.2,1.1l-.9,1.5c-.6-.6-1.5-1-2.4-.9-.7,0-1.2.4-1.2.8,0,1.2,4.7.2,4.7,3.4s-1.2,2.6-3.5,2.6c-1.3,0-2.6-.5-3.6-1.3Z"
            />
            <path
                className="st3"
                d="M120.1,26.7c-.1-2.2,1.6-4.1,3.8-4.2h.3c1.2,0,2.4.5,3.2,1.5l-1.4,1.3c-.4-.5-1-.9-1.7-.9-1.3.1-2.2,1.3-2.1,2.6.1,1.2,1,2,2.1,2.1.7,0,1.3-.3,1.7-.9l1.4,1.3c-.7,1-1.9,1.5-3.2,1.5-2.2.1-4.1-1.6-4.2-3.9,0-.1,0-.2,0-.4Z"
            />
            <path
                className="st3"
                d="M128.6,20.7c0-.7.5-1.3,1.2-1.3s1.3.5,1.3,1.2-.5,1.3-1.2,1.3h0c-.6,0-1.2-.5-1.2-1.2ZM128.9,30.7v-7.9h2.1v7.9h-2.1Z"
            />
            <path
                className="st3"
                d="M132.5,26.7c0-2.2,1.7-4.1,3.9-4.2h.2c2.4,0,3.9,1.8,3.9,4.4v.5h-5.9c.1,1.2,1.2,1.9,2.3,1.9.8,0,1.5-.3,2.1-.8l.9,1.3c-.9.7-2.1,1.2-3.3,1.1-2.2.1-4.1-1.6-4.3-3.8,0-.1,0-.3,0-.4ZM136.6,24.3c-1,0-1.9.7-1.9,1.8h3.9c-.1-1-1-1.8-2-1.8h0Z"
            />
            <path
                className="st3"
                d="M147.4,30.7v-4.8c.1-.7-.4-1.4-1.1-1.5h-.4c-.7,0-1.4.4-1.8.9v5.3h-2.1v-7.9h2.1v1c.7-.8,1.7-1.2,2.8-1.2,1.8,0,2.6,1,2.6,2.6v5.6h-2.1Z"
            />
            <path
                className="st3"
                d="M151.1,26.7c0-2.2,1.6-4.1,3.9-4.2h.3c1.2,0,2.4.5,3.2,1.5l-1.3,1.3c-.4-.5-1-.9-1.7-.9-1.3.1-2.2,1.3-2.1,2.6.1,1.2,1,2,2.1,2.1.7,0,1.3-.3,1.7-.9l1.3,1.3c-.7,1-1.9,1.5-3.2,1.5-2.2.1-4.1-1.6-4.2-3.9,0-.1,0-.2,0-.4Z"
            />
            <path
                className="st3"
                d="M159.3,26.7c0-2.2,1.7-4.1,3.9-4.2h.2c2.4,0,4,1.8,4,4.4v.5h-5.9c.1,1.2,1.2,1.9,2.3,1.9.8,0,1.5-.3,2.1-.8l.9,1.3c-.9.7-2.1,1.2-3.3,1.1-2.2.1-4.1-1.6-4.3-3.8,0-.1,0-.3,0-.4ZM163.4,24.3c-1,0-1.9.7-1.9,1.8h3.9c0-1-1-1.8-2-1.8h0Z"
            />
            <path
                className="st3"
                d="M80.5,46.1l-5.2-7.2v7.2h-2.3v-11h2.4l5,6.9v-6.9h2.3v11h-2.2Z"
            />
            <path
                className="st3"
                d="M89.6,46.1v-.8c-.7.7-1.6,1-2.5,1-1.5,0-2.7-1-2.8-2.5h0c0-2,1.5-2.7,2.8-2.7.9,0,1.9.3,2.5,1v-1.1c0-.8-.7-1.3-1.8-1.3s-1.7.3-2.3.9l-.8-1.4c1-.9,2.2-1.3,3.5-1.3,1.8,0,3.5.7,3.5,3v5.1h-2.1ZM89.6,44.2v-1c-.4-.5-1-.7-1.7-.7-.9,0-1.5.4-1.5,1.2s.7,1.2,1.5,1.2c.7,0,1.3-.2,1.7-.7h0Z"
            />
            <path
                className="st3"
                d="M99.2,46.1v-4.8c.1-.7-.4-1.3-1.1-1.5h-.4c-.7,0-1.4.4-1.8.9v5.3h-2.1v-8h2.1v1c.7-.8,1.7-1.2,2.8-1.2,1.8,0,2.6,1,2.6,2.6v5.6h-2.1Z"
            />
            <path
                className="st3"
                d="M102.8,42c0-2.3,1.9-4.2,4.2-4.3s4.2,1.9,4.3,4.2c0,2.3-1.8,4.2-4.2,4.3h0c-2.2,0-4.1-1.6-4.2-3.9v-.3ZM109.1,42c0-1.2-.7-2.3-2.1-2.3s-2,1.1-2,2.3.7,2.4,2.1,2.4,2.1-1.1,2.1-2.3h0Z"
            />
            <path
                className="st3"
                d="M122.7,46.1v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-5c0-.7-.3-1.3-1.2-1.3-.7,0-1.3.4-1.6.9v5.3h-2.1v-8h2.1v1c.7-.7,1.6-1.2,2.6-1.2,1-.1,1.9.5,2.2,1.5.6-.9,1.6-1.5,2.7-1.5s2.3.8,2.3,2.4v5.7h-2Z"
            />
            <path
                className="st3"
                d="M131.6,46.1v-.8c-.7.7-1.6,1.1-2.5,1-1.5,0-2.7-1.1-2.7-2.6h0c0-2,1.5-2.7,2.7-2.7.9,0,1.9.3,2.5,1v-1.1c0-.8-.7-1.3-1.8-1.3s-1.7.3-2.3.9l-.8-1.4c1-.9,2.2-1.3,3.5-1.3,1.8,0,3.5.7,3.5,3v5.1h-2.1ZM131.6,44.2v-1c-.4-.5-1-.7-1.7-.7-.9,0-1.5.4-1.5,1.2s.7,1.2,1.5,1.2c.7,0,1.3-.2,1.7-.7h0Z"
            />
            <path
                className="st3"
                d="M136.1,44.1v-4.1h-1.3v-1.8h1.3v-2.2h2.1v2.2h1.6v1.8h-1.6v3.6c0,.5.2.9.7.9s.5,0,.7-.2l.5,1.6c-.5.4-1.1.5-1.8.5-1.5,0-2.2-.7-2.2-2.1Z"
            />
            <path
                className="st3"
                d="M140.8,42c0-2.2,1.7-4.1,3.9-4.2h.2c2.4,0,4,1.8,4,4.4v.5h-5.9c.1,1.2,1.2,1.9,2.3,1.9.8,0,1.5-.3,2.1-.8l.9,1.3c-.9.7-2.1,1.1-3.3,1.1-2.4,0-4.3-1.6-4.3-4.2ZM144.9,39.6c-1,0-1.9.7-1.9,1.8h3.9c0-1-1-1.8-2-1.8h0Z"
            />
            <path
                className="st3"
                d="M150.4,46.1v-8h2.1v1.1c.6-.8,1.6-1.3,2.6-1.3v2.1c-.2,0-.4,0-.5,0-.7,0-1.5.4-1.9.9v5.2h-2.1Z"
            />
            <path
                className="st3"
                d="M156.1,36c0-.7.5-1.3,1.3-1.2s1.3.5,1.2,1.3c0,.7-.5,1.2-1.3,1.2-.7,0-1.2-.5-1.2-1.3ZM156.3,46.1v-8h2.1v8h-2.1Z"
            />
            <path
                className="st3"
                d="M165.2,46.1v-.8c-.7.7-1.6,1.1-2.5,1-1.5,0-2.7-1.1-2.7-2.6h0c0-2,1.5-2.7,2.7-2.7,1,0,1.9.3,2.5,1v-1.1c0-.8-.7-1.3-1.8-1.3s-1.7.3-2.3.9l-.8-1.4c1-.9,2.2-1.3,3.5-1.3,1.8,0,3.5.7,3.5,3v5.1h-2.1ZM165.2,44.2v-1c-.4-.5-1-.7-1.7-.7-.9,0-1.5.4-1.5,1.2s.7,1.2,1.5,1.2c.7,0,1.3-.2,1.7-.7h0Z"
            />
            <path className="st3" d="M169.4,46.1v-11h2.1v11h-2.1Z" />
            <path
                className="st3"
                d="M172.9,45l.9-1.5c.8.7,1.8,1,2.7,1.1.9,0,1.3-.4,1.3-.9,0-1.3-4.7-.2-4.7-3.4s1.2-2.5,3.3-2.5,2.3.4,3.2,1.1l-.9,1.4c-.6-.6-1.5-.9-2.4-.9s-1.3.4-1.3.8c0,1.2,4.7.2,4.7,3.4s-1.2,2.6-3.5,2.6c-1.2,0-2.5-.4-3.5-1.2Z"
            />
        </g>
        <path
            className="st0"
            d="M26.4.6L1.2,15.6c-.4.2-.8.6-1,1H.2l6.3,16,3.3-8.3c.5-1.2,1.1-2.2,1.9-3.3l5.7-7.2L28,0c-.5,0-1.1.4-1.6.6Z"
        />
        <path
            className="st2"
            d="M54.6,15.4L29.4.4c-.4-.3-.9-.4-1.4-.4h0l-10.6,13.9,8.7-1.3c1.2-.2,2.5-.2,3.8,0l25.7,3.8h0c-.3-.4-.6-.8-1-1Z"
        />
        <path
            className="st6"
            d="M17.4,50.9L.4,48.4h0c-.2-.4-.4-.9-.4-1.4v-29.1c0-.4.1-.9.4-1.3l9.7,24.1c.5,1.2,1.1,2.3,1.9,3.3l4.1,5.2,1.3,1.7h0Z"
        />
        <path
            className="st8"
            d="M38.6,50.8l-10.6,13.5c-.5,0-1-.1-1.4-.4L1.4,49.3c-.4-.2-.8-.5-1-1,0,0,0,0,0,0l16.9,2.5,8.8,1.3c1.3.2,2.5.2,3.8,0l8.7-1.3Z"
        />
        <path
            className="st4"
            d="M45.9,40.6c-.5,1.2-1.1,2.2-1.9,3.3l-16.2,20.4h0c.6,0,1.1-.1,1.5-.4l25.2-14.6c.4-.2.8-.6,1-1h0"
        />
        <path
            className="st7"
            d="M29.3,63.9l25.2-14.6c.4-.2.8-.6,1-1h0l-6.3-16-3.3,8.3c-.5,1.2-1.1,2.2-1.9,3.3l-16.2,20.4h0c.6,0,1.1-.1,1.5-.4Z"
        />
        <path
            className="st1"
            d="M56,47v-29.1c0-.5-.1-1-.4-1.4h0l-17-2.4,5.5,6.9c.8,1,1.4,2.1,1.9,3.3l9.6,24.2h0c.2-.4.3-.9.4-1.4Z"
        />
        <g>
            <path
                className="st5"
                d="M72.7,60.3v-1.8c3.6-2.8,4.2-3.4,4.2-4.2s-.5-.9-1.2-.9-1.6.4-2.2,1l-1.2-1.5c.9-1,2.2-1.5,3.3-1.5,1.9,0,3.3,1.2,3.3,2.9s-.9,2.5-3.1,4h3.2v2h-6.4Z"
            />
            <path
                className="st5"
                d="M83.5,51.4c2.4,0,3.5,2.2,3.5,4.5s-1.1,4.5-3.5,4.5-3.5-2.2-3.5-4.5,1.1-4.5,3.5-4.5ZM83.5,53.4c-1,0-1.4,1-1.4,2.5s.4,2.5,1.4,2.5,1.4-1,1.4-2.5-.4-2.5-1.4-2.5Z"
            />
            <path
                className="st5"
                d="M87.9,60.3v-1.8c3.6-2.8,4.2-3.4,4.2-4.2s-.5-.9-1.2-.9-1.6.4-2.2,1l-1.2-1.5c.9-1,2.2-1.5,3.3-1.5,1.9,0,3.3,1.2,3.3,2.9s-.9,2.5-3.1,4h3.2v2h-6.4Z"
            />
            <path
                className="st5"
                d="M99.2,51.4c1,0,1.9.3,2.5.8l-.9,1.7c-.5-.4-.9-.6-1.6-.6-1.1,0-1.9.9-1.9,2.1h0c.4-.5,1.2-.9,2-.9,1.5,0,2.8,1,2.8,2.9s-1.4,3.1-3.3,3.1-3.7-2-3.7-4.5,1.6-4.5,4.1-4.5ZM98.7,56.4c-.5,0-1,.2-1.4.6,0,.7.5,1.6,1.5,1.6s1.2-.5,1.2-1.1c0-.8-.7-1.1-1.3-1.1Z"
            />
        </g>
    </svg>
);
export default FooterLogo;
